import styled from 'styled-components';

export const Wrapper = styled.div`
  width: 100%;
`;

/* Faixa reservada para o alfinete da pontuação. Altura fixa para a régua não
   "pular" quando a consulta não tem pontuação (legenda pura, sem alfinete). */
export const MarkerRow = styled.div<{ compact?: boolean }>`
  position: relative;
  height: ${({ compact }) => (compact ? '28px' : '32px')};
`;

export const Marker = styled.div<{ position: number }>`
  position: absolute;
  bottom: 0;
  left: ${({ position }) => position}%;
  transform: translateX(-50%);
  display: flex;
  flex-direction: column;
  align-items: center;
`;

export const MarkerPill = styled.span`
  display: inline-flex;
  align-items: baseline;
  gap: 3px;
  padding: 3px 9px;
  border-radius: var(--radius-sm);
  background: var(--foreground);
  color: #fff;
  white-space: nowrap;

  b {
    font-family: var(--font-mono);
    font-size: 0.94rem;
    font-weight: 700;
    letter-spacing: -0.01em;
  }

  span {
    font-size: 0.62rem;
    opacity: 0.72;
  }
`;

export const MarkerArrow = styled.span`
  width: 0;
  height: 0;
  border-left: 6px solid transparent;
  border-right: 6px solid transparent;
  border-top: 7px solid var(--foreground);
`;

export const Band = styled.div<{ compact?: boolean }>`
  display: flex;
  width: 100%;
  height: ${({ compact }) => (compact ? '40px' : '48px')};
  border-radius: var(--radius-sm);
  overflow: hidden;
`;

/* Cada faixa ocupa espaço proporcional ao tamanho real do seu intervalo — é o
   que torna a régua uma legenda honesta e não uma barra decorativa de 6 partes
   iguais (a faixa F de PJ vale 18 pontos; a faixa A vale 200). */
export const Segment = styled.div<{
  weight: number;
  color: string;
  active: boolean;
  compact?: boolean;
}>`
  flex: ${({ weight }) => weight};
  min-width: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 1px;
  background: ${({ color }) => color};
  color: #fff;

  /* A classe apurada ganha um anel interno escuro. É o segundo sinal, além da
     cor: uma escala verde→vermelho é exatamente o eixo que quem tem daltonismo
     não distingue, então a classe nunca é comunicada só por cor — há o anel
     aqui, a letra dentro do segmento e o bloco da classe no topo do card. */
  box-shadow: ${({ active }) =>
    active ? 'inset 0 0 0 3px var(--foreground)' : 'none'};

  > strong {
    font-size: ${({ active, compact }) => {
      if (compact) return active ? '1rem' : '0.81rem';
      return active ? '1.38rem' : '1rem';
    }};
    font-weight: 700;
    line-height: 1;
  }

  > span {
    font-family: var(--font-mono);
    font-size: 0.62rem;
    line-height: 1;
    opacity: 0.92;
    white-space: nowrap;
  }
`;

export const Scale = styled.div`
  display: flex;
  justify-content: space-between;
  margin-top: 0.375rem;
  font-family: var(--font-mono);
  font-size: 0.62rem;
  color: var(--muted-foreground);
`;
